import { HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel, } from '@microsoft/signalr';
export function createSignalRConnection(hubUrl, accessTokenFactory) {
    const connection = new HubConnectionBuilder()
        .withUrl(hubUrl, {
        accessTokenFactory,
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true,
    })
        .withAutomaticReconnect([0, 2000, 10000, 30000])
        .configureLogging(LogLevel.Warning)
        .build();
    return { connection, HubConnectionState };
}
